<script setup lang="ts">
const { data: page } = await useAsyncData('ueberuns-community', () => queryCollection('ueberuns_community').first())

const title = page.value?.seo?.title || page.value?.title
const description = page.value?.seo?.description || page.value?.description

useSeoMeta({
  titleTemplate: '',
  title,
  ogTitle: title,
  description,
  ogDescription: description
})

const partnerLogos = [
  { name: 'Adcubum', src: '/PartnerLogos/adcubum.svg' },
  { name: 'Frontify', src: '/PartnerLogos/frontify.webp' },
  { name: 'Hostpoint', src: '/PartnerLogos/hostpoint.svg' },
  { name: 'HSR', src: '/PartnerLogos/hsr.webp' },
  { name: 'IT-SG rockt', src: '/PartnerLogos/it-sg-rockt.svg' },
  { name: 'Liip', src: '/PartnerLogos/Liip_Logo.webp' },
  { name: 'Manning', src: '/PartnerLogos/manning.webp' },
  { name: 'Multidigital', src: '/PartnerLogos/multidigital.svg' },
  { name: 'Netlify', src: '/PartnerLogos/netlify.svg' },
  { name: 'OST', src: '/PartnerLogos/ost_logo_de.webp' },
  { name: 'theStack', src: '/PartnerLogos/theStack.svg' }
]
</script>

<template>
  <div v-if="page">
    <UPageHero
      :description="page.description"
      align="left"
    >
      <template #title>
        <MDC
          :value="page.title"
          unwrap="p"
        />
      </template>
    </UPageHero>

    <UPageSection
      v-for="(section, index) in page.sections"
      :key="index"
      :title="section.title"
      :description="section.description"
      :orientation="section.orientation"
      :reverse="section.reverse ?? false"
    >
      <template #features>
        <UPageFeature
          v-for="(feature, fIndex) in section.features"
          :key="fIndex"
          :title="feature.name ?? ''"
          :description="feature.description"
          :icon="feature.icon"
        />
      </template>

      <NuxtImg
        v-if="section.image?.src"
        :src="section.image.src"
        :alt="section.image.alt || section.title"
        class="w-full rounded-lg shadow-xl"
      />
    </UPageSection>

    <USeparator />

    <UPageSection>
      <div class="text-center mb-6">
        <p class="text-sm font-semibold text-muted uppercase tracking-wider">
          Unsere Partner & Sponsoren
        </p>
      </div>
      <div class="rounded-xl bg-white py-8 overflow-hidden">
        <UMarquee
          :overlay="false"
          :pause-on-hover="true"
        >
          <div
            v-for="logo in partnerLogos"
            :key="logo.name"
            class="flex items-center justify-center h-16 mx-10"
          >
            <NuxtImg
              :src="logo.src"
              :alt="logo.name"
              class="h-10 w-auto object-contain"
            />
          </div>
        </UMarquee>
      </div>
    </UPageSection>

    <USeparator />

    <UPageCTA
      v-if="page.cta"
      v-bind="page.cta"
      variant="naked"
      class="overflow-hidden"
    >
      <LazyStarsBg />
    </UPageCTA>
  </div>
</template>
